<template>
    <div class="station-selection">
        <div class="inner">
            <div class="selection">
                <p class="byline">{{ $t('byline') }}</p>
                <h2 class="h1">{{ $t('heading') }}</h2>
                <p>{{ $t('text') }}</p>
                <a
                    class="terms"
                    href="/palvelut/ennakkotilaus/ennakko-ja-ryhmatilauksen-ehdot"
                    target="_Blank"
                >
                    {{ $t('terms') }}
                </a>
                <DSCombobox
                    :key="`combobox-${station ? station.id : 0}`"
                    :label="$t('selectStation')"
                    :options="stationSelections"
                    :initial-value="station ? station.id : 0"
                    @change="stationSelected"
                />
            </div>
            <div class="progress">
                <div class="connector"></div>
                <template v-for="item, key in [1, 2, 3, 4]" :key="`number-${key}`">
                    <span class="number">{{ item }}</span>
                    <span class="title">{{ $t(`step${item}`) }}</span>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'StationSelection',
    props: {
        stations: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    emits: ['change'],
    data: () => ({
        value: 0,
    }),
    computed: {
        stationSelections() {
            if (this.stations.length > 0) {
                return [{
                        value: 0,
                        name: '-',
                    },
                    ...this.stations.map(station => ({
                        value: station.id,
                        name: station.title,
                    })),
                ];
            }

            return null;
        },
    },
    mounted() {
        if (this.$route.query && this.$route.query.station) {
            const station = this.stations.find(station => station.links.find(link => link.to.replace(/^\/asemat\//, '') === this.$route.query.station));

            if (station) {
                this.value = station.id;
            }
        }
    },
    methods: {
        stationSelected(selection) {
            this.$emit('change', {
                id: selection.value,
            });
        },
    },
    i18n: {
        messages: {
            fi: {
                default: {
                    byline: 'Tilaa Helmisimpukoiden',
                    heading: 'Herkut ennakkoon soittamalla',
                    text: 'Valitse asema ja näet saatavilla olevan ruokalistan. Voit tilata herkut ennakkoon soittamalla asemalle.',
                    terms: 'Ennakko- ja ryhmätilauksen ehdot',
                    selectStation: 'Valitse asema',
                    step1: 'Valitse asema ja tuotteet',
                    step2: 'Tarkista tilauksesi tuotteet',
                    step3: 'Soita asemalle tehdäksesi tilauksen',
                    step4: 'Nouda tilauksesi ja maksa asemalla',
                },
            },
        },
    },
};
</script>
<style scoped>
.station-selection {
  background: var(--color-secondary-500);
  display: grid;
  max-width: var(--desktop-max-width);
  width: 100%;
  margin: 0 auto;
}
.station-selection .inner {
  max-width: var(--page-max-width);
  margin: 0 auto;
  padding-left: 1.5rem;
  width: 100%;
  padding-right: 1.5rem;
}
.station-selection .inner {
  padding-top: 4rem;
  padding-bottom: 4rem;
  display: grid;
  grid-template-columns: 2fr 1fr;
  align-items: center;
}
@media (max-width: 991px) {
  .station-selection .inner {
    grid-template-columns: 1fr;
    grid-gap: 2rem 0;
  }
}
.station-selection .selection {
  max-width: 515px;
}
.station-selection .selection .byline {
  font-weight: 700;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
.station-selection .progress {
  position: relative;
  display: grid;
  grid-template-columns: 40px 1fr;
  grid-gap: 2.25rem 1rem;
  align-items: center;
}
.station-selection .progress .connector {
  position: absolute;
  width: 0.25rem;
  height: calc(100% - 2rem);
  top: 1rem;
  left: 18px;
  background: var(--color-primary-500);
}
.station-selection .progress .number {
  position: relative;
  z-index: 1;
  display: inline-flex;
  width: 40px;
  height: 40px;
  background: var(--color-primary-500);
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: var(--color-base-white);
}
.station-selection .progress .title {
  font-weight: 700;
}
.station-selection .terms {
  display: inline-block;
  color: var(--color-primary-900);
  font-weight: 700;
  margin-bottom: 2rem;
}
</style>
